<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    :item-text="itemText"
    :label="label"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs"
    >
    <template v-slot:item="item">
      <slot name="item" v-bind:item="item">
        <px-chip-codigo-interno class="mr-1"
                                :codigo-interno="item.item.codigoInterno"/>
        <template v-if="!showDetails">
          <span>{{ item.item[itemText] }}</span>
        </template>
        <template v-else>
          <span><strong>{{ item.item.descricao }}</strong></span>
        </template>
      </slot>
    </template>
    <template v-slot:selection="item">
      <div class="truncate-text">
        <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
        {{ item.item.descricao }}
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import TiposUsoService from '@/api/tipos-uso-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
    itemText: {
      type: String,
      default: 'descricao',
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Tipos de uso',
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue.descricao === val)) return;
      this.debounceSearch(val);
    },
    value() {
      if (this.value) {
        this.items = [this.value, ...this.items];
      }
    },
  },
  methods: {
    buildQuery(val) {
      return `ativo is true and (descricao like "%${val.toLowerCase()}%" or codigoInterno like "%${val.toLowerCase()}%")`;
    },
    searchItems(val) {
      const searchValue = val || '';

      this.loading = true;
      TiposUsoService.getList({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: this.buildQuery(searchValue),
      })
        .then((response) => {
          this.items = this.value ? [this.value, ...response.data.content] : response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    if (this.value) {
      this.items = [this.value];
    }
  },
};
</script>
